import { useAuthorization } from '@entities/authentication'
import { couponEntityMutations } from '@entities/coupon'
import { useMutation } from '@tanstack/react-query'

type UseCheckCouponForPaymentProps = {
  couponId: Nullable<string>
  subscribeId: string
  productId?: string | null
}

export const useCheckCouponForPayment = ({ couponId, subscribeId, productId }: UseCheckCouponForPaymentProps) => {
  const authorization = useAuthorization()
  return useMutation({
    ...couponEntityMutations.checkCouponForPayment({
      couponId,
      subscribeId,
      productId,
      bearerToken: authorization.bearerToken,
    }),
  })
}
